var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        visible: _vm.visible,
        id: "admin-user-auth-token-modal",
        title: "Redeem User Auth Token",
        "hide-footer": "",
        centered: "",
      },
      on: { "bv::modal::show": _vm.maybeLoadToken },
    },
    [
      _vm.loading
        ? [
            _c(
              "div",
              { staticClass: "text-center" },
              [_c("b-spinner", { attrs: { label: "Spinning" } })],
              1
            ),
          ]
        : [
            _c("p", [_c("strong", [_vm._v("User Auth Token:")])]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.authToken))]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }